const KEY = "kb_consultas";
const MAX = 10;

export const ConsultasService = {
  get() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  },

  add(question) {
    const consultas = this.get();
    consultas.unshift({
      texto: question,
      fecha: new Date().toISOString(),
    });
    localStorage.setItem(KEY, JSON.stringify(consultas.slice(0, MAX)));
  },

  clear() {
    localStorage.removeItem(KEY);
  },
};
